import React, { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = signed out

  useEffect(() => {
    const t = localStorage.getItem("idea_token");
    if (!t) {
      setUser(null);
      return;
    }
    client
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("idea_token");
        setUser(null);
      });
  }, []);

  const loginAdmin = async (email, password) => {
    const { data } = await client.post("/auth/admin/login", { email, password });
    localStorage.setItem("idea_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const loginTechnician = async (station_id, pin) => {
    const { data } = await client.post("/auth/technician/login", { station_id, pin });
    localStorage.setItem("idea_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const loginSales = async (email, password) => {
    const { data } = await client.post("/auth/sales/login", { email, password });
    localStorage.setItem("idea_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("idea_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loginAdmin, loginTechnician, loginSales, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
